import { getOrdersById, getOrdersSearch } from '@/api'

export const PAYMENT_CONFIRMING_LOCK_KEY = 'shop-cart-payment-confirming-lock'
export const PAYMENT_CONFIRMING_REORDER_MESSAGE = '相同商品已有訂單，付款結果尚未確認完成。'
export const PAYMENT_CONFIRMING_CART_UPDATED_MESSAGE = '上一筆付款已完成，購物車已更新。'

export function getPaymentConfirmingLock () {
  try {
    return JSON.parse(localStorage.getItem(PAYMENT_CONFIRMING_LOCK_KEY) || 'null')
  } catch (error) {
    localStorage.removeItem(PAYMENT_CONFIRMING_LOCK_KEY)
    return null
  }
}

export function setPaymentConfirmingLock (payload) {
  const lock = {
    order_id: payload.order_id || '',
    order_number: payload.order_number || payload.order_no || '',
    cart_items: normalizeProductQuantityItems(payload.cart_items || payload.order_items || []),
    created_at: payload.created_at || new Date().toISOString()
  }

  localStorage.setItem(PAYMENT_CONFIRMING_LOCK_KEY, JSON.stringify(lock))
  return lock
}

export function clearPaymentConfirmingLock () {
  localStorage.removeItem(PAYMENT_CONFIRMING_LOCK_KEY)
}

export function resolveOrderPaymentState (order) {
  if (!order) {
    return 'unknown'
  }

  const orderStatus = Number(order.order_status)
  if ([9, 10, 11, 12, 13, 14, 23].includes(orderStatus)) {
    return 'failed'
  }

  if (orderStatus === 2) {
    return 'pending'
  }

  if ([3, 4, 5, 6, 7, 8].includes(orderStatus)) {
    return 'paid'
  }

  return 'unknown'
}

export function findExactPaymentOrder (data, orderNumber) {
  const orders = Array.isArray(data) ? data : data && Array.isArray(data.data) ? data.data : [data]
  return orders.find(order => order && String(order.order_number) === String(orderNumber)) || null
}

export async function getLockedOrder () {
  const lock = getPaymentConfirmingLock()
  if (!lock) {
    return {
      lock: null,
      order: null,
      state: 'none'
    }
  }

  try {
    const order = await fetchLockedOrder(lock)
    const state = resolveOrderPaymentState(order)

    if (state === 'paid' || state === 'failed') {
      clearPaymentConfirmingLock()
    }

    return {
      lock,
      order,
      state
    }
  } catch (error) {
    return {
      lock,
      order: null,
      state: 'pending'
    }
  }
}

export async function checkPaymentConfirmingReorderConflict (cartItems) {
  const result = await getLockedOrder()
  if (!result.lock) {
    return result
  }

  if (result.state === 'paid' || result.state === 'failed') {
    return result
  }

  const orderItems = result.order && result.order.order_items && result.order.order_items.length
    ? result.order.order_items
    : result.lock.cart_items

  return {
    ...result,
    hasSameItems: isSameProductQuantity(orderItems, cartItems)
  }
}

export function normalizeProductQuantityItems (items) {
  const bucket = {}

  ;(items || []).forEach(item => {
    if (!item || item.activity_id) {
      return
    }

    const productId = Number(
      item.product_id ||
      (item.products && item.products.id) ||
      item.id ||
      0
    )
    const quantity = Number(item.quantity || item.product_quantity || 0)

    if (!productId || !quantity) {
      return
    }

    bucket[productId] = (bucket[productId] || 0) + quantity
  })

  return Object.keys(bucket)
    .sort((left, right) => Number(left) - Number(right))
    .map(productId => ({
      product_id: Number(productId),
      quantity: bucket[productId]
    }))
}

export function isSameProductQuantity (leftItems, rightItems) {
  const left = normalizeProductQuantityItems(leftItems)
  const right = normalizeProductQuantityItems(rightItems)

  if (left.length !== right.length) {
    return false
  }

  return left.every((item, index) => {
    return item.product_id === right[index].product_id && item.quantity === right[index].quantity
  })
}

async function fetchLockedOrder (lock) {
  if (lock.order_id) {
    const response = await getOrdersById(lock.order_id)
    return response && response.data
  }

  if (lock.order_number) {
    const response = await getOrdersSearch({
      order_number: lock.order_number
    })
    const data = response && response.data

    return findExactPaymentOrder(data, lock.order_number)
  }

  return null
}
